import React, { forwardRef } from 'react';
import classnames from 'classnames';

// Components
import { Portal } from '../portal/Portal';
import { useMergeRefs, FloatingArrow } from '@floating-ui/react';

import './WpPopoverOverlay.scss';

const WpPopoverOverlay = forwardRef<HTMLDivElement, React.HTMLProps<HTMLDivElement> & { context }>(
  function WpPopoverOverlay({ children, context }, propRef) {
    const ref = useMergeRefs([context.refs.setFloating, propRef]);

    if (!context.open) return null;

    const baseClassName = 'WpPopoverOverlay';
    const classes = classnames(
      baseClassName,
      context.withStyling ? `${baseClassName}--styled` : '',
      context.withBoxShadow ? `${baseClassName}--shadow` : '',
      context.withPadding ? `${baseClassName}--padding` : ''
    );

    return (
      <Portal idPrefix="tooltip">
        <div
          ref={ref}
          style={{
            ...context.floatingStyles,
            maxWidth: context.maxWidth,
          }}
          className={classes}
        >
          {context.showArrow && (
            <FloatingArrow
              ref={context.arrowRef}
              context={context.context}
              tipRadius={2}
              className={`${baseClassName}__arrow`}
            />
          )}
          {children}
        </div>
      </Portal>
    );
  }
);

export default WpPopoverOverlay;
